import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../LabelText';
import TextareaAutosize from 'react-textarea-autosize';

const Address = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const userData = useSelector(state => state.userData);

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = 'address';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					// Explicitly specify the element selector
					selector: `textarea[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<TextareaAutosize
				name="address"
				placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
				className="form-control-sm mb-3 form-control"
				id="address"
				defaultValue={(userData && userData.address) || ''}
				minRows="3"
			/>
		</div>
	);
}

export default Address;